import { render, staticRenderFns } from "./treasury-form-420.vue?vue&type=template&id=3827b2ec&scoped=true&"
import script from "./treasury-form-420.vue?vue&type=script&lang=js&"
export * from "./treasury-form-420.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3827b2ec",
  null
  
)

export default component.exports